import React, { useState, useEffect, useRef, useCallback } from "react";
import Logo from "../images/logo.svg";
import Select from "react-select";
import Sidebar from "../component/Sidebar";
import {
  SelectPicker,
  Placeholder,
  Message,
  Whisper,
  Tooltip,
  Popover,
  Button,
  Loader,
} from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { Link, useNavigate } from "react-router-dom";
import * as bootstrap from "bootstrap";
import { ReactComponent as IconStarOutline } from "../images/star-outline.svg";
import { ReactComponent as IconStar } from "../images/IconStar.svg";
import debounce from "lodash.debounce";
import IconInfo from "../images/IconErrorInfo.svg";
import IconError from "../images/IconError.svg";
import IconCheckError from "../images/IconCheckError.svg";
import Open_Link_Icon from "../images/Open_link_round.svg";
import IconJson from "../images/IconJSONAction.svg";
import "aos/dist/aos.css";
import AOS from "aos";
import { Center } from "@chakra-ui/react";
import CheckIcon from "@rsuite/icons/Check";
import CloseIcon from "@rsuite/icons/Close";
import iconFinnhubUpload from "../images/icon-finnhub-upload.svg";
import iconFinnhub from "../images/iconFinnhub.svg";
import { motion, AnimatePresence } from "framer-motion";
import Lottie from "lottie-react";
import animationData1 from "../lottie/1.json";
import animationData2 from "../lottie/2.json";
import animationData3 from "../lottie/3.json";
import animationData4 from "../lottie/4.json";
import animationData5 from "../lottie/5.json";
import animationData6 from "../lottie/6.json";
import { ChakraProvider, useToast, Wrap } from "@chakra-ui/react";

const stepAnimations = {
  0: animationData1,
  1: animationData2,
  2: animationData3,
  3: animationData4,
  4: animationData5,
  5: animationData6,
};

function CompanyProfile() {
  const [tabName, setTabName] = useState("Company Profile");
  useEffect(() => {
    document.title = tabName;
  }, [tabName]);

  useEffect(() => {
    AOS.init();
  }, []);

  const [isLoading, setLoading] = useState(true); // State to manage loading state
  const navigate = useNavigate();
  const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
  const apiEndPoint1 = process.env.REACT_APP_API_ENDPOINT_TEMP;
  const frontEndLink = process.env.REACT_APP_MUSAFFA_LINK;
  const roleName = localStorage.getItem("novaRolename");
  const merlinJuniorAnalyst = process.env.REACT_APP_MERLIN_JUNIOR_ANALYST;
  const abortControllerRef = useRef(null);

  const [reportData, setReportData] = useState([]);
  const [reportCount, setReportCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [startPage, setStartPage] = useState(1);
  const [countryCode, setCountryCode] = useState("");
  const [countryFinnhubCode, setCountryFinnhubCode] = useState("");
  const [complianceId, setComplianceId] = useState("");
  const [statusId, setStatusId] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [pageRange, setPageRange] = useState("20");

  const [countryData, setCountryData] = useState([]);
  const [complianceData, setComplianceData] = useState([]);
  const [statusData, setStatusData] = useState([]);

  const [selectedQuarter, setSelectedQuarter] = useState("");

  const userid = localStorage.getItem("novauserid");
  const progressStatus = process.env.REACT_APP_TASK_MANAGER_PROGRESS_Status;

  const [errorMessage, setErrorMessage] = useState("");
  const [messageType, setMessageType] = useState(null); // success, error, info

  const [exchangeData, setExchangeData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [fetchCompanySymbol, setFetchCompanySymbol] = useState("");
  const [fetchCompanyExchange, setFetchCompanyExchange] = useState(null);

  const handleQuaterChange = (selectedOption) => {
    setSelectedQuarter(selectedOption); // Update selectedPeriod state with the selected option
  };

  //Country List
  useEffect(() => {
    const fetchCountryList = async () => {
      const url = ` ${apiEndPoint}/get_all_country_list`;
      const payload = {
        data: {
          user_id: userid, // Replace with the actual user_id if dynamic
        },
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await response.json();
        const data = responseData.data; // Flatten the response

        const formattedCountryData = data.data.map((country) => ({
          label: country.country_name,
          value: country.country_code,
        }));

        setCountryData(formattedCountryData);
      } catch (error) {
        console.log(error);
      }
    };

    fetchCountryList();
  }, []);

  //Exchange List
  useEffect(() => {
    const fetchExchangeList = async () => {
      const url = ` ${apiEndPoint1}/exchange_symbol_list`;
      const payload = {
        data: {
          user_id: userid, // Replace with the actual user_id if dynamic
        },
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await response.json();
        const data = responseData.data; // Flatten the response
        // console.log("exchange_symbol_list : ",data);

        const formattedExchangeData = data.symbols.map((exchange) => ({
          label: exchange.exchange_symbol,
          value: exchange.exchange_symbol,
        }));
        setExchangeData(formattedExchangeData);
      } catch (error) {
        console.log(error);
      }
    };

    fetchExchangeList();
  }, []);

  //Currency List
  useEffect(() => {
    const fetchCurrencyList = async () => {
      const url = ` ${apiEndPoint1}/currency_symbol_list`;
      const payload = {
        data: {
          user_id: userid, // Replace with the actual user_id if dynamic
        },
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await response.json();
        const data = responseData.data; // Flatten the response
        console.log("currency_symbol_list : ", data);
        console.log("currency_symbol_list symbols: ", data.symbols);

        // Handle different possible response structures
        let currencyArray = [];
        if (data.symbols && Array.isArray(data.symbols)) {
          currencyArray = data.symbols;
        } else if (data.currencies && Array.isArray(data.currencies)) {
          currencyArray = data.currencies;
        } else if (data.data && Array.isArray(data.data)) {
          currencyArray = data.data;
        } else if (Array.isArray(data)) {
          currencyArray = data;
        }

        const formattedCurrencyData = currencyArray.map((currency) => {
          let currencyValue;
          if (typeof currency === "string") {
            currencyValue = currency;
          } else if (currency && typeof currency === "object") {
            // Handle the actual API response structure: {currency: 'AED'}
            currencyValue =
              currency.currency ||
              currency.currency_symbol ||
              currency.symbol ||
              currency.name ||
              currency.value ||
              currency.label ||
              currency;
          } else {
            currencyValue = String(currency);
          }

          // Ensure we have a valid string value
          if (!currencyValue || typeof currencyValue !== "string") {
            currencyValue = "Unknown";
          }

          return {
            label: currencyValue,
            value: currencyValue,
          };
        });

        console.log("formattedCurrencyData: ", formattedCurrencyData);

        // Validate the data structure
        const validCurrencyData = formattedCurrencyData.filter(
          (item) =>
            item &&
            typeof item === "object" &&
            item.label &&
            item.value &&
            typeof item.label === "string" &&
            typeof item.value === "string"
        );

        console.log("Valid currency data: ", validCurrencyData);

        // Ensure we have valid data structure
        if (validCurrencyData.length === 0) {
          console.warn(
            "No valid currency data found, setting default currencies"
          );
          setCurrencyData([
            { label: "USD", value: "USD" },
            { label: "EUR", value: "EUR" },
            { label: "GBP", value: "GBP" },
            { label: "JPY", value: "JPY" },
            { label: "CAD", value: "CAD" },
            { label: "AUD", value: "AUD" },
            { label: "CHF", value: "CHF" },
            { label: "CNY", value: "CNY" },
            { label: "INR", value: "INR" },
            { label: "BRL", value: "BRL" },
          ]);
        } else {
          setCurrencyData(validCurrencyData);
        }
      } catch (error) {
        console.log("Currency API error:", error);
        // Set default currencies on error
        setCurrencyData([
          { label: "USD", value: "USD" },
          { label: "EUR", value: "EUR" },
          { label: "GBP", value: "GBP" },
          { label: "JPY", value: "JPY" },
          { label: "CAD", value: "CAD" },
          { label: "AUD", value: "AUD" },
          { label: "CHF", value: "CHF" },
          { label: "CNY", value: "CNY" },
          { label: "INR", value: "INR" },
          { label: "BRL", value: "BRL" },
        ]);
      }
    };

    fetchCurrencyList();
  }, []);

  // Compliance List
  useEffect(() => {
    const fetchComplianceStatusList = async () => {
      const url = `${apiEndPoint}/get_compliance_status`;
      const payload = {
        data: {
          user_id: userid, // Replace with the actual user_id if dynamic
        },
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await response.json();
        const data = responseData.data; // Flatten the response

        const formattedComplianceStatusData = data.data.map((complaince) => ({
          label: complaince.name,
          value: complaince.id,
        }));

        setComplianceData(formattedComplianceStatusData);
      } catch (error) {
        console.log(error);
      }
    };

    fetchComplianceStatusList();
  }, []);

  //Status List
  useEffect(() => {
    const fetchStatusList = async () => {
      const url = `${apiEndPoint}/get_status`;
      const payload = {
        data: {
          user_id: userid, // Replace with the actual user_id if dynamic
        },
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await response.json();
        const data = responseData.data; // Flatten the response

        const formattedStatusData = data.data.map((status) => ({
          label: status.name,
          value: status.id,
        }));

        setStatusData(formattedStatusData);
      } catch (error) {
        console.log(error);
      }
    };

    fetchStatusList();
  }, []);

  const fetchGlobalReport = async () => {
    setLoading(true);

    // Cancel the previous request if any
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Create a new AbortController for the current request
    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      const apiUrl = `${apiEndPoint}/get_company_listing`;
      const requestData = {
        data: {
          user_id: userid,
          limit: pageRange,
          page: currentPage.toString(),
          q: searchInput,
          country_code: countryCode,
          AAOIFI_status: complianceId,
          status: statusId,
        },
      };
      // console.log(JSON.stringify(requestData));
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
        signal: controller.signal,
      });

      const jsonData = await response.json();
      const { status, message, count, data } = jsonData.data;
      if (status == "success") {
        setLoading(false);
        setReportCount(count);
        // console.log("RES :" + searchInput + " : " + JSON.stringify(data));
        setReportData(data);
      } else {
        console.error("Error: ", message);
      }
    } catch (error) {
      if (error.name === "AbortError") {
        // console.log("Request cancelled");
      } else {
        console.error("Error fetching data:", error.message);
      }
      return false;
    }
  };

  const debouncedFetchGlobalReport = useCallback(
    debounce(() => {
      fetchGlobalReport();
    }, 500),
    [searchInput] // Only debounce on search input changes
  );

  useEffect(() => {
    debouncedFetchGlobalReport();
    return () => {
      debouncedFetchGlobalReport.cancel();
    };
  }, [searchInput]);

  useEffect(() => {
    fetchGlobalReport();
  }, [currentPage, countryCode, complianceId, statusId, pageRange]); // Regular effect for other dependencies

  const data2 = [
    { label: "Q1", value: 1 },
    { label: "Q2", value: 2 },
    { label: "Q3", value: 3 },
    { label: "Q4", value: 4 },
  ];

  const handleSearch = (event) => {
    console.log(event.target.value);

    setSearchInput(event.target.value);
    setCurrentPage(1); // Reset to the first page for new search
  };

  const handleCountryChange = (value) => {
    setCountryCode(value);
  };

  const handleComplianceChange = (value) => {
    setComplianceId(value);
  };

  const handleStatusChange = (value) => {
    setStatusId(value);
  };

  const handleAddNewReport = async (companyId) => {
    // Fetch the specific company details based on companyId if needed
    const selectedCompany = reportData.find(
      (company) => company.row_id === companyId
    );

    // Example: Accessing company data
    if (selectedCompany) {
      const tickerAndCompanyName =
        selectedCompany.date + " : " + selectedCompany.company_symbol;
      const reportSource = document.getElementById(
        `reportSource_${companyId}`
      ).value;

      if (!reportSource) {
        setErrorMessage("Please Enter Report Year");
        setMessageType("error");
        return false;
      }
      if (!selectedQuarter) {
        setErrorMessage("Please Select Quater");
        setMessageType("error");
        return false;
      }

      const date = selectedCompany.date;
      const company_symbol = selectedCompany.company_symbol;
      const year = reportSource;
      const quarter = selectedQuarter;

      //await checkTask(selectedCompany,reportSource,selectedQuarter)
      //await updateReportStatus(userid,company_symbol,date,quarter,year,selectedCompany.companyId);
      const taskCheckSuccess = await checkTask(
        selectedCompany,
        reportSource,
        selectedQuarter
      );
      if (taskCheckSuccess) {
        const cancelButton = document.getElementById(`Cancel_${companyId}`);
        if (cancelButton) {
          cancelButton.click();
        }
        await updateReportStatus(
          userid,
          company_symbol,
          date,
          quarter,
          year,
          selectedCompany.companyId
        );
      }
    }
  };

  const checkTask = async (selectedCompany, reportSource, selectedQuarter) => {
    try {
      const res = await fetch(`${apiEndPoint}/check_task`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            user_id: userid,
            company_symbol: selectedCompany.company_symbol,
            quarter: selectedQuarter,
            year: reportSource,
            is_ipo: 0,
          },
        }),
      });

      const result = await res.json();

      if (result.data.status === "Success") {
        // setErrorMessage(result.data.message);
        // setMessageType('success');
        // return false;
        return true;
      } else {
        setErrorMessage(result.data.message);
        setMessageType("error");
        return false;
      }
    } catch (err) {
      console.log("Check Report : Error : " + err.message);
      setErrorMessage("An error occurred while checking the task");
      setMessageType("error");
      return false; // Indicate failure
    }
  };

  const updateReportStatus = async (
    userid,
    company_symbol,
    date,
    quarter,
    year,
    companyId
  ) => {
    const url = `${apiEndPoint}/update_tasks`;

    const payload = {
      data: {
        user_id: userid, // Replace this with the actual user_id if dynamic
        company_symbol: company_symbol, // Assuming itemId represents company_symbol
        date: date, // Replace this with the actual date if dynamic
        quarter: quarter, // Replace this with the actual quarter if dynamic
        year: year, // Replace this with the actual year if dynamic
        status: progressStatus,
        is_ipo: 0,
        is_frm_company: 1,
      },
    };

    console.log(JSON.stringify(payload));
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.json();
      const data = responseData.data; // Flatten the response
      if (data.status === "success") {
        //window.open(`/report/ancasdasdas`, '_blank');

        navigate(`/report/${data.data.encryptJSON}`);
        //
        return true; // Indicate success
      } else {
        console.error("API Error:", data.data.message);
        return false; // Indicate failure
      }
    } catch (error) {
      console.error("API Error:", error);
      return false; // Indicate failure
    }
  };

  const [customPaginationValue, setCustomPaginationValue] = useState("");

  // Debounced function to update the page number
  const debouncedSetPage = useCallback(
    debounce((page) => {
      setCurrentPage(page);
    }, 500), // Delay of 500ms (half a second)
    []
  );

  const handlePaginationChange = (e) => {
    const value = (e.target.value == 0 ? 1 : e.target.value).toString();
    setCustomPaginationValue(value); // Update input value immediately for fast typing
    debouncedSetPage(Number(value)); // Trigger the debounced function
  };

  const handlePagelimit = (value) => {
    setCurrentPage(1);
    setCustomPaginationValue(1);
    setPageRange(value);
  };

  const renderPagination = () => {
    // Calculate total number of pages
    const totalPages = Math.ceil(reportCount / pageRange);

    // Show a default of 3 pages if the total pages are more than 3
    const pageNumbers = [];
    const visiblePageCount = 4; // Number of pages to show by default

    let startPage = currentPage - 1;
    let endPage = currentPage + 2;

    // Adjust pagination if total pages are less than the default
    if (totalPages <= visiblePageCount) {
      startPage = 1;
      endPage = totalPages;
    } else {
      // Ensure the pagination does not go out of bounds
      startPage = Math.max(1, startPage);
      endPage = Math.min(totalPages, endPage);
    }

    // Create page numbers to display based on current page
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <nav
        aria-label="..."
        id="pagination_row"
        style={{
          alignItems: "center",
          justifyContent: "space-between",
          background: "#FFF",
          paddingTop: 0,
          paddingBottom: 0,
        }}
      >
        <div className="totalRecords">
          Total Records : {Number(reportCount).toLocaleString()}
        </div>
        <ul className="pagination" style={{ border: 0, background: "none" }}>
          <li class="page-item" style={{ marginLeft: 10 }}>
            <SelectPicker
              onChange={handlePagelimit}
              cleanable={false}
              value={pageRange}
              placement="top"
              placeholder="Pages"
              data={PagingData}
              searchable={false}
              style={{
                width: 85,
                height: 35,
                display: "flex",
                alignItems: "center",
                borderRadius: 5,
                border: "1px solid #A1B9ED",
              }}
            />
          </li>

          {/* Previous Page (Double Arrow) */}
          <li
            className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
            style={{ marginLeft: 10 }}
          >
            <a href="#" className="page-link" onClick={() => setCurrentPage(1)}>
              <i className="fa fa-angle-double-left"></i>
            </a>
          </li>

          {/* Previous Page (Single Arrow) */}
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <a
              href="#"
              className="page-link"
              onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
            >
              <i className="fa fa-angle-left"></i>
            </a>
          </li>

          {/* Page numbers */}
          {pageNumbers.map((page) => (
            <li
              key={page}
              className={`page-item ${currentPage === page ? "active" : ""}`}
            >
              <a
                className="page-link"
                href="#"
                onClick={() => setCurrentPage(page)} // Set the clicked page as the current page
              >
                {page}
              </a>
            </li>
          ))}

          {/* Next Page (Single Arrow) */}
          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
          >
            <a
              href="#"
              className="page-link"
              onClick={() =>
                setCurrentPage(Math.min(totalPages, currentPage + 1))
              }
            >
              <i className="fa fa-angle-right"></i>
            </a>
          </li>

          {/* Next Page (Double Arrow) */}
          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
            style={{ marginRight: 10 }}
          >
            <a
              href="#"
              className="page-link"
              onClick={() => setCurrentPage(totalPages)}
            >
              <i className="fa fa-angle-double-right"></i>
            </a>
          </li>

          {/* Go to Page */}
          <li
            className="page-item"
            style={{
              marginLeft: 10,
              display: "flex",
              alignItems: "center",
              gap: 5,
            }}
          >
            <input
              type="text"
              placeholder="Go#"
              className="form-control"
              value={customPaginationValue}
              onChange={handlePaginationChange}
              onInput={(e) => {
                // Only allow numbers
                e.target.value = e.target.value.replace(/[^0-9]/g, "");
              }}
              style={{
                padding: "0px 10px",
                color: "#878787",
                fontSize: 16,
                borderRadius: 5,
                border: "1px solid #A1B9ED",
                width: 60,
                height: 35,
                textAlign: "center",
              }}
            />
          </li>
        </ul>
      </nav>
    );
  };

  // PAGINATION
  const PagingData = ["10", "20", "50", "100"].map((item) => ({
    label: item,
    value: item,
  }));

  const handleClearFilters = () => {
    setCurrentPage(1);
    setCountryCode("");
    setSearchInput("");
    setComplianceId("");
    setStatusId("");
  };

  const renderStars = (ranking) => {
    const fullStars = Math.floor(ranking);
    const stars = [];
    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        stars.push(
          <li key={i}>
            <IconStar />
          </li>
        );
      } else {
        stars.push(
          <li key={i}>
            <IconStarOutline />
          </li>
        );
      }
    }
    return stars;
  };

  const hideMessage = () => {
    setMessageType(null);
  };

  const renderMessage = () => {
    if (messageType) {
      setTimeout(hideMessage, 4000);
    }

    switch (messageType) {
      case "success":
        return (
          <Message
            type="success"
            closable
            style={{
              display: "flex",
              alignItems: "center",
              width: "auto",
              position: "fixed",
              right: 10,
              top: 10,
              zIndex: 99999,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <div className="icon_error_msg Icon_success">
                <div className="icon_error_msg_inner Icon_success_inner">
                  <img src={IconCheckError} alt="Success Icon" />
                  <div className="progress-circle progress_circle_success"></div>
                </div>
              </div>
              <div className="error_msg_text error_msg_success_text">
                <h5>Success</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
      case "error":
        return (
          <Message
            type="error"
            closable
            style={{
              display: "flex",
              alignItems: "center",
              width: "auto",
              position: "fixed",
              right: 10,
              top: 10,
              zIndex: 99999,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <div className="icon_error_msg Icon_error">
                <div className="icon_error_msg_inner Icon_error_inner">
                  <img src={IconError} alt="Error Icon" />
                  <div className="progress-circle progress_circle_error"></div>
                </div>
              </div>
              <div className="error_msg_text error_msg_error_text">
                <h5>Error</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
      case "info":
        return (
          <Message
            type="info"
            closable
            style={{
              display: "flex",
              alignItems: "center",
              width: "auto",
              position: "fixed",
              right: 10,
              top: 10,
              zIndex: 99999,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <div className="icon_error_msg Icon_info">
                <div className="icon_error_msg_inner Icon_info_inner">
                  <img src={IconInfo} alt="Info Icon" />
                  <div className="progress-circle progress_circle_info"></div>
                </div>
              </div>
              <div className="error_msg_text error_msg_info_text">
                <h5>Info</h5>
                <p>No reports found for the selected priority</p>
              </div>
            </div>
          </Message>
        );
      default:
        return null;
    }
  };

  const [openStatusPopover, setOpenStatusPopover] = useState(null);
  const [publishSymbol, setPublishSymbol] = useState("");
  // Function to handle checkbox click
  const handleCheckboxClick = (item) => {
    // Toggle the popover visibility for the specific item
    setPublishSymbol(item.company_symbol);
    if (openStatusPopover === item.id) {
      setOpenStatusPopover(null); // Close the popover if it's already open
    } else {
      setOpenStatusPopover(item.id); // Open the popover
    }
  };

  // Function to handle deletion confirmation
  const handlePublishConfirm = async (company) => {
    try {
      // Perform the API call
      const response = await fetch(`${apiEndPoint}/update_company_status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            user_id: userid,
            status: company.report_status ? "0" : "1",
            symbol: company.company_symbol, // Assuming 'company.symbol' holds the company symbol
          },
        }),
      });

      // Parse the response as JSON
      const result = await response.json();

      // Handle the response based on the status
      if (response.ok && result.data.status === "success") {
        // Show success message
        console.log(result.data.message); // e.g., "Company status updated successfully"
        // Optionally, you can display a UI notification or message here
        fetchGlobalReport();
        // Close the popover after confirmation
        setOpenStatusPopover(null);
      } else {
        // Handle failure case (if any)
        console.error(
          "Failed to update company status:",
          result.data.message || "Unknown error"
        );
        // Optionally, display an error message in the UI
      }
    } catch (error) {
      console.error("Error:", error);
      // Handle any network or unexpected errors
    }
  };

  const handleCheckboxChange = (e, item) => {
    setPublishSymbol(item.company_symbol);
    //e.stopPropagation(); // Prevents the event from bubbling up
    // Handle the checkbox change here
    // You can check e.target.checked to see if it's checked or unchecked
  };

  const toast = useToast();
  const toastIdRef = React.useRef();

  // FETCH FINNHUB
  const [failedStep, setFailedStep] = useState(null);
  const [currentStep, setCurrentStep] = useState(-1);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [loading2, setLoading2] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  const [closeEnabled, setCloseEnabled] = useState(false);

  // State for missing fields form
  const [missingFieldsForm, setMissingFieldsForm] = useState({
    exchange_symbol: "",
    ticker: "",
    currency: "",
    marketCapCurrency: "",
    country: "",
    shareOutstanding: "",
    marketCapitalization: "",
  });

  const [currentAnimation, setCurrentAnimation] = useState(animationData1);
  const [showExchangeConfirmModal, setShowExchangeConfirmModal] =
    useState(false);
  const animationMap = [
    animationData1,
    animationData2,
    animationData3,
    animationData4,
    animationData6,
    animationData6,
  ];

  const handleFinnhubCountryChange = (value) => {
    setCountryFinnhubCode(value);
    setMissingFieldsForm((prev) => ({ ...prev, country: value }));
  };

  // Handle missing fields form input changes
  const handleMissingFieldChange = (field, value) => {
    setMissingFieldsForm((prev) => ({ ...prev, [field]: value }));
  };

  const steps = [
    "Getting Data from Finnhub",
    "Storing in the Database",
    "Data Cleaning",
    "Validating Data...",
    "Added to Production",
    "Company Data Successfully Pushed to Typesense",
  ];

  const stepsConfig = [
    {
      label: "Getting Data from Finnhub",
      action: async () => {
        try {
          // Step 0: API call
          const response = await fetch(`${apiEndPoint1}/addnewcompany_finhub`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              data: {
                user_id: userid,
                exchange: fetchCompanyExchange,
                company_symbol: fetchCompanySymbol,
                // Include missing fields if this is a restart
                ...(missingFields.length > 0 &&
                  Object.keys(missingFieldsForm).reduce((acc, key) => {
                    if (missingFieldsForm[key]) {
                      acc[key] = missingFieldsForm[key];
                    }
                    return acc;
                  }, {})),
              },
            }),
          });

          // Check HTTP status first
          if (response.status === 404) {
            // HTTP 404 - Data not found
            setFailedStep(0);
            setCurrentAnimation(animationData5);
            setLoading2(false);
            setCompletedSteps([]); // No steps completed

            // Show error toast
            toastIdRef.current = toast({
              description: "Data not found for this symbol",
              status: "error",
              duration: 5000,
              isClosable: true,
              position: "bottom",
            });

            // Return false to stop execution
            return false;
          }

          const result = await response.json();

          // If API returns error with missing fields (HTTP 200 but error in response)
          if (result?.data?.status === "error") {
            // Check if it's missing fields error
            if (Array.isArray(result?.data?.data?.missing_fields)) {
              setMissingFields(result.data.data.missing_fields);
              // Mark steps 0, 1, 2 as completed for missing fields case
              setCompletedSteps([0, 1, 2]);
              setCurrentStep(3);
              setCurrentAnimation(animationData5);
              // Mark step 3 (Validating Data...) as failed
              setFailedStep(3);
              setLoading2(false); // Stop loading
              // Return false to stop execution
              return false;
            }

            // Other error types in response - mark step 0 as failed and stop
            setFailedStep(0);
            setCurrentAnimation(animationData5);
            setLoading2(false);
            setCompletedSteps([]); // No steps completed

            // Show error toast
            toastIdRef.current = toast({
              description:
                result?.data?.message ||
                "An error occurred while fetching data",
              status: "error",
              duration: 5000,
              isClosable: true,
              position: "bottom",
            });

            // Return false to stop execution
            return false;
          }

          // Success case → clear missing fields
          setMissingFields([]);

          if (!response.ok || result?.data?.status !== "success") {
            throw new Error(
              result?.data?.message ||
                "Failed at step: Getting Data from Finnhub"
            );
          }

          // Step 0 done
          setCompletedSteps((prev) => [...prev, 0]);

          // Step 1
          setCurrentStep(1);
          setCurrentAnimation(animationMap[1]);
          await new Promise((resolve) => setTimeout(resolve, 1000));
          setCompletedSteps((prev) => [...prev, 1]);

          // Step 2
          setCurrentStep(2);
          setCurrentAnimation(animationMap[2]);
          await new Promise((resolve) => setTimeout(resolve, 1000));
          setCompletedSteps((prev) => [...prev, 2]);

          // Return true to indicate success and continue
          return true;
        } catch (error) {
          console.error(error);
          // Mark step 0 as failed for any other errors
          setFailedStep(0);
          setCurrentAnimation(animationData5);
          setLoading2(false);

          // Don't mark any steps as completed for catch block errors
          setCompletedSteps([]);

          // Return false to stop execution
          return false;
        }
      },
    },
    {
      label: "Storing in the Database",
      action: async () => {}, // Handled in Step 0
    },
    {
      label: "Data Cleaning",
      action: async () => {}, // Handled in Step 0
    },
    {
      label: "Validating Data...",
      action: async () => {
        await new Promise((resolve) => setTimeout(resolve, 1000));
      },
    },
    {
      label: "Added to Production",
      action: async () => {
        // Don't proceed if we have missing fields
        if (missingFields.length > 0) {
          return;
        }

        const response = await fetch(`${apiEndPoint1}/push_cp_typesense`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            data: {
              user_id: userid,
              company_symbol: fetchCompanySymbol,
            },
          }),
        });

        const result = await response.json();

        if (!response.ok || result?.data?.status !== "success") {
          throw new Error(
            result?.data?.message || "Failed at step: Added to Production"
          );
        }

        // ✅ Step 4 done
        setCompletedSteps((prev) => [...prev, 4]);

        // ✅ Only if success, mark step 5 as done
        setCurrentStep(5);
        setCurrentAnimation(animationMap[5]);
        await stepsConfig[5].action();
        setCompletedSteps((prev) => [...prev, 5]);

        setCloseEnabled(true);
        setLoading2(false);
        // Don't set currentStep to -1, keep it at 5 to show the final animation
        // setCurrentStep(-1); // Remove this line

        // Show the final success animation
        setCurrentAnimation(animationData6);

        toastIdRef.current = toast({
          description: "Symbol successfully Added",
          status: "success",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
      },
    },
    {
      label: "Company Data Successfully Pushed to Musaffa",
      action: async () => {
        // Simulate processing time for the final step
        await new Promise((resolve) => setTimeout(resolve, 1000));
      },
    },
  ];

  const handleAdd = async () => {
    let hasError = false;

    if (!fetchCompanySymbol.trim()) {
      toastIdRef.current = toast({
        description: "Company symbol is required",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      hasError = true;
    }

    if (hasError) return;

    setLoading2(true);
    setCompletedSteps([]);
    setCurrentStep(0);
    setFailedStep(null);
    setMissingFields([]); // Clear any previous missing fields

    try {
      setCurrentStep(0);
      setCurrentAnimation(animationMap[0]);

      // Execute step 0 and check if it should continue
      const step0Result = await stepsConfig[0].action();

      // If step 0 returns false or throws an error, stop execution
      if (step0Result === false) {
        setLoading2(false);
        return; // Stop processing
      }

      // If we have missing fields, we need to handle this case specifically
      if (missingFields.length > 0) {
        // First, show step 1 (Storing in the Database) with loader
        setCurrentStep(1);
        setCurrentAnimation(animationMap[1]);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        setCompletedSteps([0, 1]); // Mark step 1 as completed

        // Then show step 2 (Data Cleaning) with loader
        setCurrentStep(2);
        setCurrentAnimation(animationMap[2]);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        setCompletedSteps([0, 1, 2]); // Mark step 2 as completed

        // Finally show step 3 (Validating Data...) with loader
        setCurrentStep(3);
        setCurrentAnimation(animationMap[3]);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        setCompletedSteps([0, 1, 2, 3]); // Mark step 3 as completed

        // Now mark step 4 as failed
        setFailedStep(4);
        setCurrentAnimation(animationData5);
        setLoading2(false);
        return; // Stop processing
      }

      // If we reached here, step 0 succeeded without missing fields
      setCompletedSteps((prev) => [...prev, 0]);

      // Step 3: Validating Data
      setCurrentStep(3);
      setCurrentAnimation(animationMap[3]);
      await stepsConfig[3].action();
      setCompletedSteps((prev) => [...prev, 3]);

      // Step 4: Added to Production
      setCurrentStep(4);
      setCurrentAnimation(animationMap[4]);
      await stepsConfig[4].action();
      setCompletedSteps((prev) => [...prev, 4]);

      // Step 5: Company Data Successfully Pushed to Typesense
      setCurrentStep(5);
      setCurrentAnimation(animationMap[5]);
      await stepsConfig[5].action();
      setCompletedSteps((prev) => [...prev, 5]);

      setCloseEnabled(true);
      setLoading2(false);
      setCurrentStep(-1);
    } catch (error) {
      console.error(`Step failed:`, error.message);
      setFailedStep(currentStep);
      setCurrentAnimation(animationData5);
      setLoading2(false);
    }
  };

  const renderIcon = (index) => {
    if (failedStep === index) {
      return (
        <CloseIcon
          style={{ color: "#DA293E", marginRight: "8px", width: 13 }}
        />
      );
    } else if (completedSteps.includes(index)) {
      return (
        <CheckIcon
          style={{ color: "#0A8F43", marginRight: "8px", width: 13 }}
        />
      );
    } else if (loading2 && currentStep === index) {
      return <Loader size="xs" style={{ marginRight: "8px", width: 13 }} />;
    } else {
      return (
        <span
          style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            backgroundColor: "#878787",
            marginTop: 5,
            display: "inline-block",
            marginRight: "10px",
          }}
        />
      );
    }
  };

  const [showTooltip, setShowTooltip] = useState(window.innerWidth < 1500);

  useEffect(() => {
    const handleResize = () => {
      setShowTooltip(window.innerWidth < 1500);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClose = () => {
    // Reset all states
    setCompletedSteps([]);
    setCurrentStep(-1);
    setFailedStep(null);
    setMissingFields([]);
    setMissingFieldsForm({
      exchange_symbol: "",
      ticker: "",
      currency: "",
      marketCapCurrency: "",
      country: "",
      shareOutstanding: "",
      marketCapitalization: "",
    });
    setCloseEnabled(false);
    setLoading2(false);
  };

  // Reset form and try again with different symbol
  const handleTryAgain = () => {
    setCompletedSteps([]);
    setCurrentStep(-1);
    setFailedStep(null);
    setMissingFields([]);
    setMissingFieldsForm({
      exchange_symbol: "",
      ticker: "",
      currency: "",
      marketCapCurrency: "",
      country: "",
      shareOutstanding: "",
      marketCapitalization: "",
    });
    setCloseEnabled(false);
    setLoading2(false);
    setCurrentAnimation(animationMap[0]);
    // Clear the symbol input so user can enter a new one
    setFetchCompanySymbol("");
    setFetchCompanyExchange(null);
  };

  // Handle saving missing fields and restarting the process
  const handleSaveMissingFields = async () => {
    // Validate that all missing fields are filled
    const allFieldsFilled = missingFields.every((field) => {
      const value = missingFieldsForm[field];
      return value && value.toString().trim() !== "";
    });

    if (!allFieldsFilled) {
      toastIdRef.current = toast({
        description: "Please fill all required fields",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      return;
    }

    try {
      // Call API to update missing fields
      const response = await fetch(
        `${apiEndPoint1}/update_missing_company_fields`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            data: {
              company_symbol: fetchCompanySymbol,
              fields: {
                ...(missingFieldsForm.exchange_symbol && {
                  exchange_symbol: missingFieldsForm.exchange_symbol,
                }),
                ...(missingFieldsForm.ticker && {
                  ticker: missingFieldsForm.ticker,
                }),
                ...(missingFieldsForm.currency && {
                  currency: missingFieldsForm.currency,
                }),
                ...(missingFieldsForm.marketCapCurrency && {
                  marketCapCurrency: missingFieldsForm.marketCapCurrency,
                }),
                ...(missingFieldsForm.country && {
                  country: missingFieldsForm.country,
                }),
                ...(missingFieldsForm.shareOutstanding && {
                  shareOutstanding: missingFieldsForm.shareOutstanding,
                }),
                ...(missingFieldsForm.marketCapitalization && {
                  marketCapitalization: missingFieldsForm.marketCapitalization,
                }),
              },
            },
          }),
        }
      );

      const result = await response.json();

      if (response.ok && result?.data?.status === "success") {
        // Clear missing fields
        setMissingFields([]);
        setMissingFieldsForm({
          exchange_symbol: "",
          ticker: "",
          currency: "",
          marketCapCurrency: "",
          country: "",
          shareOutstanding: "",
          marketCapitalization: "",
        });

        // Mark step 3 (Validating Data...) as completed
        setCompletedSteps([0, 1, 2, 3]);
        setCurrentStep(4);
        setCurrentAnimation(animationMap[4]);
        setFailedStep(null); // Clear the failed step

        // Continue with step 4: Added to Production
        try {
          const typesenseResponse = await fetch(
            `${apiEndPoint1}/push_cp_typesense`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                data: {
                  user_id: userid,
                  company_symbol: fetchCompanySymbol,
                },
              }),
            }
          );

          const typesenseResult = await typesenseResponse.json();

          if (
            !typesenseResponse.ok ||
            typesenseResult?.data?.status !== "success"
          ) {
            throw new Error(
              typesenseResult?.data?.message ||
                "Failed at step: Added to Production"
            );
          }

          // ✅ Step 4 done
          setCompletedSteps((prev) => [...prev, 4]);

          // ✅ Step 5: Company Data Successfully Pushed to Typesense
          setCurrentStep(5);
          setCurrentAnimation(animationMap[5]);
          await stepsConfig[5].action();
          setCompletedSteps((prev) => [...prev, 5]);

          setCloseEnabled(true);
          setLoading2(false);

          // Show the final success animation
          setCurrentAnimation(animationData6);

          toastIdRef.current = toast({
            description: "Symbol successfully Added",
            status: "success",
            duration: 5000,
            isClosable: true,
            position: "bottom",
          });
        } catch (error) {
          console.error("Error in step 4:", error);
          setFailedStep(4);
          setCurrentAnimation(animationData5);
          setLoading2(false);

          toastIdRef.current = toast({
            description: error.message || "Failed at step: Added to Production",
            status: "error",
            duration: 5000,
            isClosable: true,
            position: "bottom",
          });
        }
      } else {
        toastIdRef.current = toast({
          description:
            result?.data?.message || "Failed to update missing fields",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
      }
    } catch (error) {
      console.error("Error updating missing fields:", error);
      toastIdRef.current = toast({
        description: "An error occurred while updating missing fields",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
    }
  };

  return (
    <>
      <Sidebar />
      <div id="header">
        <div className="logo">
          <div className="logo_icon">
            <img src={Logo} alt="Logo" />
          </div>
          <div className="brand_name">Company Profile</div>
        </div>

        <div className="header_table_filter">
          <div className="searchfield">
            <button className="btn_search">
              <i className="icon-search2"></i>
            </button>
            <input
              type="text"
              className="filter_searchfield"
              placeholder="Search"
              autocomplete="off"
              onChange={handleSearch}
              value={searchInput}
            />
          </div>

          <div className="dropdown_col_filter dropdown__select">
            <SelectPicker
              data={statusData}
              searchable={false}
              style={{ width: 180 }}
              placeholder="Both Status"
              onChange={handleStatusChange}
              value={statusId}
            />
          </div>

          <div className="dropdown_col_filter dropdown__select">
            <SelectPicker
              data={countryData}
              searchable={false}
              style={{ width: 170 }}
              placeholder="Filter by Country"
              onChange={handleCountryChange}
              value={countryCode}
            />
          </div>

          <div className="dropdown_col_filter dropdown__select">
            <SelectPicker
              data={complianceData}
              searchable={false}
              style={{ width: 180 }}
              placeholder="All Compliance"
              onChange={handleComplianceChange}
              value={complianceId}
            />
          </div>

          <a
            href="javascript:void(0)"
            className="btn_clear_filter"
            style={{ textDecoration: "none" }}
            onClick={handleClearFilters}
          >
            Clear Filters
          </a>
        </div>
        <div className="header_monthly_value btn__group_header">
          <Whisper
            placement="left"
            trigger="hover"
            speaker={showTooltip ? <Tooltip>Add New</Tooltip> : <span />}
          >
            <Link to="/AddNewCompanyProfile" className="btn_add_new">
              <i className="icon-plus2"></i>
              <span>Add New</span>
            </Link>
          </Whisper>

          <Whisper
            placement="left"
            trigger="hover"
            speaker={
              showTooltip ? <Tooltip>Fetch from Finnhub</Tooltip> : <span />
            }
          >
            <button
              type="button"
              className="btn__fetch_finnhub"
              data-bs-toggle="modal"
              data-bs-target="#ModalFinnhub"
              onClick={() => {
                setCompletedSteps([]);
                setCurrentStep(-1);
                setFailedStep(null);
                setCurrentAnimation(animationMap[0]);
                setMissingFields([]);
                setMissingFieldsForm({
                  exchange_symbol: "",
                  ticker: "",
                  currency: "",
                  marketCapCurrency: "",
                  country: "",
                  shareOutstanding: "",
                  marketCapitalization: "",
                });
                setCloseEnabled(false);
                setLoading2(false);
                // Clear the input fields and dropdown values
                setFetchCompanySymbol("");
                setFetchCompanyExchange(null);
              }}
            >
              <img src={iconFinnhub} alt="Finnhub Icon" />
              <span>Fetch from Finnhub</span>
            </button>
          </Whisper>
        </div>
      </div>
      <div className="container-fluid content pb-5">
        <div className="company_table_list">
          {isLoading && (
            <Placeholder.Grid
              rows={20}
              columns={9}
              active
              style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }}
            />
          )}

          {/* Table */}
          {!isLoading && (
            <>
              <div className="table-responsive clsPagingWrap">
                <table className="table">
                  <thead>
                    <tr>
                      <th style={{ textAlign: "center" }}>Status</th>
                      <th>Ticker and Company Name</th>
                      <th>Market Cap</th>
                      <th>Classification</th>
                      <Whisper
                        placement="top"
                        controlId="control-id-hover"
                        trigger="hover"
                        speaker={
                          <Tooltip>
                            Combined Country and Exchange information
                          </Tooltip>
                        }
                      >
                        <th style={{ cursor: "pointer" }}>Country</th>
                      </Whisper>
                      <th>ISIN</th>
                      <th>Compliance</th>
                      <th style={{ textAlign: "center" }}>Status</th>
                      <th>Rating</th>
                      <th>Updated</th>
                      <th>LAD</th>
                      <th style={{ textAlign: "center" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportData.length > 0 ? (
                      reportData.map((company, index) => (
                        <tr key={index}>
                          <td style={{ textAlign: "center" }}>
                            <Whisper
                              placement="right"
                              trigger="click"
                              open={openStatusPopover === company.id}
                              onClose={() => setOpenStatusPopover(null)}
                              speaker={
                                <Popover
                                  className="tooltip_form Rsuite_popover"
                                  preventOverflow
                                >
                                  <div className="tooltip_form_inner text-center">
                                    <div
                                      style={{
                                        fontSize: 20,
                                        color: "#141B3C",
                                        fontWeight: 600,
                                        lineHeight: 1.3,
                                      }}
                                    >
                                      Are you sure you want to <br />
                                      {company.report_status
                                        ? "deactivate"
                                        : "activate"}{" "}
                                      {publishSymbol} company?
                                    </div>

                                    <div className="btn__group mt-5">
                                      <a
                                        href="#"
                                        className="btn__cancel"
                                        onClick={() =>
                                          setOpenStatusPopover(null)
                                        }
                                      >
                                        Cancel
                                      </a>
                                      <a
                                        href="#"
                                        className="btn__assign"
                                        onClick={() =>
                                          handlePublishConfirm(company)
                                        }
                                      >
                                        Confirm
                                      </a>
                                    </div>
                                  </div>
                                </Popover>
                              }
                            >
                              <Button
                                className="btn_assign"
                                onClick={() => setOpenStatusPopover(company.id)}
                              >
                                <div>
                                  <Whisper
                                    placement="right"
                                    controlId="control-id-hover"
                                    trigger="hover"
                                    speaker={
                                      <Tooltip>
                                        You Can Active/InActive From Here
                                      </Tooltip>
                                    }
                                  >
                                    <label className="switchSmall">
                                      <input
                                        type="checkbox"
                                        onChange={(e) =>
                                          handleCheckboxChange(e, company)
                                        }
                                        checked={company.report_status}
                                      />
                                      <small></small>
                                    </label>
                                  </Whisper>
                                </div>
                              </Button>
                            </Whisper>
                          </td>
                          <td>
                            <div className="company_name_td">
                              <span className="company_lable">
                                {company.company_symbol}
                              </span>
                              <div className="clogo">
                                <img src={company.logo} />
                              </div>
                              {company.name}
                            </div>
                          </td>
                          <td>
                            {" "}
                            {company.daily_market_cap
                              ? `${company.currency} ${company.daily_market_cap}`
                              : ""}
                          </td>
                          <td>{company.marketCapClassification}</td>
                          <td>
                            {company.country} - {company.exchange_symbol}
                          </td>
                          <td>
                            {/* onClick={() => copyText(company.isin)} */}
                            <div className="table_td_big_content_url">
                              {company.isin}
                              {/* {copiedText === company.isin && <div className='copied_text'>Copied!</div>} */}
                            </div>
                          </td>
                          <td>
                            {company.AAOIFI_status != null && (
                              <span
                                className={`tag_td ${
                                  company.AAOIFI_status == "0" ||
                                  company.AAOIFI_status == null
                                    ? ""
                                    : company.AAOIFI_status == "1"
                                    ? "halal_tag"
                                    : company.AAOIFI_status == "2"
                                    ? "not_halal_tag"
                                    : company.AAOIFI_status == "3"
                                    ? "doughtful_tag"
                                    : company.AAOIFI_status == "4"
                                    ? "uncover_tag"
                                    : "doubtful_tag"
                                }`}
                                style={{ width: 75 }}
                              >
                                {company.AAOIFI_status_name === "NON_COMPLIANT"
                                  ? "NCMPT"
                                  : company.AAOIFI_status_name === "COMPLIANT"
                                  ? "CMPT"
                                  : company.AAOIFI_status_name ===
                                    "QUESTIONABLE"
                                  ? "DBTF"
                                  : company.AAOIFI_status_name}
                              </span>
                            )}
                          </td>

                          <td style={{ textAlign: "center" }}>
                            {company.publish_un_publish}
                          </td>

                          <td>
                            {/* <ul className="rating_list"> {renderStars(company.ranking)} </ul> */}
                            {company.rating}
                          </td>
                          <td>{company.finhub_updated_date}</td>
                          <td>{company.nova_updated_date}</td>
                          <td>
                            <div
                              className="action_row"
                              style={{
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <h5>
                                {" "}
                                <Link
                                  className="btn_create_report"
                                  data-bs-toggle="modal"
                                  data-bs-target={`#CreateReportModal_${company.row_id}`}
                                >
                                  {" "}
                                  Create Report{" "}
                                </Link>{" "}
                              </h5>
                              <Link
                                to="/AddNewCompanyProfile"
                                state={{ id: company.id }}
                                className={`btn_icon_action ${
                                  company.is_manual == 0 ? "action_disable" : ""
                                }`}
                              >
                                {" "}
                                <i
                                  className="icon-edit"
                                  style={{
                                    cursor: "pointer",
                                    verticalAlign: "middle",
                                  }}
                                ></i>{" "}
                              </Link>
                              <Link
                                to={`/ComplianceProfileReports/${company.company_symbol}`}
                                target="_blank"
                                className="btn_icon_action"
                              >
                                {" "}
                                <img
                                  src={IconJson}
                                  height="28"
                                  style={{ verticalAlign: "middle" }}
                                />{" "}
                              </Link>
                              <Link
                                to={`${frontEndLink}/${company.company_symbol}`}
                                target="_blank"
                                className="btn_icon_action"
                              >
                                {" "}
                                <img
                                  src={Open_Link_Icon}
                                  style={{
                                    cursor: "pointer",
                                    height: 28,
                                    verticalAlign: "middle",
                                  }}
                                />{" "}
                              </Link>
                            </div>
                          </td>

                          {/* Modal */}
                          <div
                            className="modal fade duplicate_form_modal"
                            id={`CreateReportModal_${company.row_id}`}
                            tabIndex="-1"
                            aria-labelledby={`DuplicateFormModalLabel_${company.row_id}`}
                            aria-hidden="true"
                          >
                            {renderMessage()}
                            <div className="modal-dialog modal-dialog-centered">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h1 className="modal-title fs-5">
                                    {company.truncated_name}
                                  </h1>
                                </div>
                                <div className="modal-body">
                                  <div className="duplicate_form_content">
                                    <div className="duplicate_form_row">
                                      <div className="duplicate_form_col">
                                        <label>Report Source</label>
                                        <input
                                          type="text"
                                          id={`reportSource_${company.row_id}`}
                                          className="form-control"
                                          placeholder="YYYY"
                                        />
                                      </div>

                                      <div className="duplicate_form_col">
                                        <label>Filling Type</label>
                                        <div className="select_drop_picker">
                                          <SelectPicker
                                            data={data2}
                                            searchable={false}
                                            style={{ width: 250 }}
                                            placeholder="Quarter"
                                            onChange={handleQuaterChange}
                                            value={selectedQuarter}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="btn__group">
                                      <button
                                        type="button"
                                        className="btn_cancel"
                                        data-bs-dismiss="modal"
                                        id={`Cancel_${company.row_id}`}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        type="button"
                                        className="btn_duplicate btn_add_new_report"
                                        onClick={() =>
                                          handleAddNewReport(company.row_id)
                                        }
                                      >
                                        Add New Report
                                      </button>
                                      {/* <button type="button" className="btn_duplicate btn_add_new_report" onClick={() => handleAddNewReport(company.row_id)}>Add New Report</button> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* End Modal */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" style={{ textAlign: "center" }}>
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {reportCount > 0 && renderPagination()}
            </>
          )}
        </div>
      </div>

      <div
        class="modal fade modal_finnhub_fetch"
        id="ModalFinnhub"
        tabindex="-1"
        aria-labelledby="AddNewAnalystModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header" style={{ width: "100%" }}>
              <div>
                <h5>Fetch Company Data from Finnhub</h5>
                <p>Enter the Company Symbol to fetch and process data</p>
              </div>
            </div>
            <div class="modal-body finnhub_fetch_body">
              <div className="finnhub_fetch_row">
                <div className="finnhub_fetch_col">
                  <label>
                    Enter Company Symbol<span className="star_red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter the company symbol manually"
                    value={fetchCompanySymbol}
                    onChange={(e) =>
                      setFetchCompanySymbol(e.target.value.toUpperCase())
                    }
                  />
                </div>
                <div className="finnhub_fetch_col2">
                  <label>
                    Enter Exchange<span className="star_red">*</span>
                  </label>
                  <div className="select_drop_picker">
                    <SelectPicker
                      data={exchangeData}
                      searchable={false}
                      style={{ width: "100%" }}
                      placeholder="Select the Exchange"
                      value={fetchCompanyExchange}
                      onChange={(value) => setFetchCompanyExchange(value)}
                    />
                  </div>
                </div>
                <ChakraProvider>
                  <Wrap>
                    <Button
                      className="btn__fetch_add"
                      onClick={() => {
                        if (
                          !fetchCompanySymbol ||
                          fetchCompanySymbol.trim() === ""
                        ) {
                          toastIdRef.current = toast({
                            description: "Please enter a company symbol first",
                            status: "error",
                            duration: 3000,
                            isClosable: true,
                            position: "bottom",
                          });
                          return;
                        }

                        if (!fetchCompanyExchange) {
                          toastIdRef.current = toast({
                            description: "Please select an exchange first",
                            status: "error",
                            duration: 3000,
                            isClosable: true,
                            position: "bottom",
                          });
                          return;
                        }

                        // ✅ Both validations passed
                        setShowExchangeConfirmModal(true);
                      }}
                    >
                      <i className="icon-plus"></i> Add
                    </Button>
                  </Wrap>
                </ChakraProvider>
              </div>
              <div className="finnhub_animation_section">
                <ul className="finnhub_anim_list">
                  {stepsConfig.map((step, index) => {
                    const isFailed = failedStep === index;
                    const isCompleted = completedSteps.includes(index);
                    const hasMissingFields =
                      missingFields.length > 0 && index === 0;

                    return (
                      <li
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          marginBottom: "8px",
                          color: isFailed
                            ? "#DA293E"
                            : isCompleted
                            ? "#0A8F43"
                            : "#696969",
                        }}
                      >
                        {isFailed ? (
                          <CloseIcon
                            style={{
                              color: "#DA293E",
                              marginRight: "8px",
                              width: 13,
                            }}
                          />
                        ) : (
                          renderIcon(index)
                        )}
                        <span>{step.label}</span>
                      </li>
                    );
                  })}
                </ul>

                <div className="icon_finnhub_col">
                  <Lottie animationData={currentAnimation} loop autoplay />
                </div>
              </div>

              <AnimatePresence>
                {failedStep !== null && (
                  <motion.div
                    className="finnhub_invalid_form_row"
                    initial={{ opacity: 0, y: -50, height: 0 }}
                    animate={{ opacity: 1, y: 0, height: "auto" }}
                    exit={{ opacity: 0, y: -50, height: 0 }}
                    transition={{ duration: 0.7, ease: "easeInOut" }}
                  >
                    {/* Dynamically create rows with max 3 fields per row */}
                    {(() => {
                      const rows = [];
                      const fieldsPerRow = 3;

                      for (
                        let i = 0;
                        i < missingFields.length;
                        i += fieldsPerRow
                      ) {
                        const rowFields = missingFields.slice(
                          i,
                          i + fieldsPerRow
                        );
                        rows.push(
                          <div
                            key={i}
                            className="finnhub_form_row"
                            style={{
                              display: "flex",
                              gap: "20px",
                              marginBottom: "20px",
                            }}
                          >
                            {rowFields.map((field) => {
                              // Render different input types based on field name
                              if (field === "exchange_symbol") {
                                return (
                                  <div
                                    key={field}
                                    className="finnhub_fetch_col2"
                                    style={{ flex: 1 }}
                                  >
                                    <label>
                                      Exchange Symbol
                                      <span className="star_red">*</span>
                                    </label>
                                    <div className="select_drop_picker clsFinhubbDdl">
                                      <SelectPicker
                                        data={exchangeData}
                                        searchable={false}
                                        style={{ width: "100%" }}
                                        placeholder="Select Exchange Symbol"
                                        value={
                                          missingFieldsForm.exchange_symbol
                                        }
                                        onChange={(value) =>
                                          handleMissingFieldChange(
                                            "exchange_symbol",
                                            value
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                );
                              } else if (field === "ticker") {
                                return (
                                  <div
                                    key={field}
                                    className="finnhub_invalid_form_col"
                                    style={{ flex: 1 }}
                                  >
                                    <label>
                                      Ticker<span className="star_red">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Ticker"
                                      value={missingFieldsForm.ticker}
                                      onChange={(e) =>
                                        handleMissingFieldChange(
                                          "ticker",
                                          e.target.value.toUpperCase()
                                        )
                                      }
                                    />
                                  </div>
                                );
                              } else if (field === "currency") {
                                return (
                                  <div
                                    key={field}
                                    className="finnhub_fetch_col2"
                                    style={{ flex: 1 }}
                                  >
                                    <label>
                                      Currency
                                      <span className="star_red">*</span>
                                    </label>
                                    <div className="select_drop_picker clsFinhubbDdl">
                                      <SelectPicker
                                        data={currencyData}
                                        searchable={false}
                                        style={{ width: "100%" }}
                                        placeholder="Select Currency"
                                        value={missingFieldsForm.currency}
                                        onChange={(value) =>
                                          handleMissingFieldChange(
                                            "currency",
                                            value
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                );
                              } else if (field === "marketCapCurrency") {
                                return (
                                  <div
                                    key={field}
                                    className="finnhub_fetch_col2"
                                    style={{ flex: 1 }}
                                  >
                                    <label>
                                      Market Cap Currency
                                      <span className="star_red">*</span>
                                    </label>
                                    <div className="select_drop_picker clsFinhubbDdl">
                                      <SelectPicker
                                        data={currencyData}
                                        searchable={false}
                                        style={{ width: "100%" }}
                                        placeholder="Select Market Cap Currency"
                                        value={
                                          missingFieldsForm.marketCapCurrency
                                        }
                                        onChange={(value) =>
                                          handleMissingFieldChange(
                                            "marketCapCurrency",
                                            value
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                );
                              } else if (field === "country") {
                                return (
                                  <div
                                    key={field}
                                    className="finnhub_fetch_col2"
                                    style={{ flex: 1 }}
                                  >
                                    <label>
                                      Country<span className="star_red">*</span>
                                    </label>
                                    <div className="select_drop_picker clsFinhubbDdl">
                                      <SelectPicker
                                        data={countryData}
                                        searchable={false}
                                        style={{ width: "100%" }}
                                        placeholder="Select Country"
                                        onChange={handleFinnhubCountryChange}
                                        value={missingFieldsForm.country}
                                      />
                                    </div>
                                  </div>
                                );
                              } else if (field === "shareOutstanding") {
                                return (
                                  <div
                                    key={field}
                                    className="finnhub_invalid_form_col"
                                    style={{ flex: 1 }}
                                  >
                                    <label>
                                      Shares Outstanding
                                      <span className="star_red">*</span>
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      placeholder="Enter Shares Outstanding"
                                      value={missingFieldsForm.shareOutstanding}
                                      onChange={(e) =>
                                        handleMissingFieldChange(
                                          "shareOutstanding",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                );
                              } else if (field === "marketCapitalization") {
                                return (
                                  <div
                                    key={field}
                                    className="finnhub_invalid_form_col"
                                    style={{ flex: 1 }}
                                  >
                                    <label>
                                      Market Capitalization
                                      <span className="star_red">*</span>
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      placeholder="Enter Market Capitalization"
                                      value={
                                        missingFieldsForm.marketCapitalization
                                      }
                                      onChange={(e) =>
                                        handleMissingFieldChange(
                                          "marketCapitalization",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                );
                              }
                              return null;
                            })}
                          </div>
                        );
                      }
                      return rows;
                    })()}
                  </motion.div>
                )}
              </AnimatePresence>

              <div class="btn__group mt-5" style={{}}>
                {missingFields.length > 0 && (
                  <>
                    <Button
                      type="button"
                      className="btn_cancel"
                      id="CancelDelete"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Button>
                    <Button
                      className="btn_delete"
                      onClick={handleSaveMissingFields}
                    >
                      Save
                    </Button>
                  </>
                )}

                {(failedStep === 0 || failedStep === 3) &&
                  !missingFields.length && (
                    <Button onClick={handleTryAgain} className="btn__fetch_add">
                      Try Again
                    </Button>
                  )}

                <Button
                  onClick={handleClose}
                  className="btn_cancel"
                  data-bs-dismiss="modal"
                  isDisabled={!closeEnabled}
                  style={{
                    display: missingFields.length > 0 ? "none" : "inline-block",
                  }}
                >
                  {" "}
                  Close{" "}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Exchange Confirmation Modal */}
      <AnimatePresence>
        {showExchangeConfirmModal && (
          <motion.div
            className="modal fade show"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            style={{
              display: "block",
              backgroundColor: "rgba(0,0,0,0.5)",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 9999,
            }}
          >
            <div
              className="modal-dialog modal-dialog-centered"
              style={{ margin: "0 auto", width: "350px" }}
            >
              <motion.div
                className="modal-content"
                initial={{ opacity: 0, y: 20, scale: 0.9 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: 20, scale: 0.9 }}
                transition={{ duration: 0.3, ease: "easeOut" }}
                style={{
                  background: "#fff",
                  borderRadius: "12px",
                  boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
                  border: "2px solid #A1B9ED",
                  padding: "20px",
                  minWidth: "300px",
                  textAlign: "center",
                  alignItems: "center",
                }}
              >
                <p
                  style={{
                    color: "#696969",
                    fontSize: "15px",
                    marginBottom: "15px",
                    fontWeight: "500",
                  }}
                >
                  Are you sure this is the correct exchange?
                </p>

                <div
                  style={{
                    background: "#f8f9fa",
                    padding: "12px",
                    borderRadius: "8px",
                    border: "1px solid #A1B9ED",
                    marginBottom: "15px",
                    width: "90%",
                  }}
                >
                  <strong style={{ fontSize: "16px", color: "#141B3C" }}>
                    {fetchCompanyExchange}
                  </strong>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                  }}
                >
                  <button
                    type="button"
                    className="btn_cancel"
                    onClick={() => setShowExchangeConfirmModal(false)}
                    style={{ padding: "8px 16px", fontSize: "14px" }}
                  >
                    No, Cancel
                  </button>
                  <button
                    type="button"
                    className="btn_delete"
                    onClick={() => {
                      setShowExchangeConfirmModal(false);
                      handleAdd();
                    }}
                    style={{
                      padding: "8px 10px",
                      fontSize: "14px",
                      justifyContent: "space-around",
                    }}
                  >
                    <i className="icon-plus"></i> Yes, Continue
                  </button>
                </div>
              </motion.div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}

export default CompanyProfile;
